import React,{ useState , useEffect } from "react";
import { Colors, Web_url } from "../../../common/Const";
import { images } from "../../../common/Images";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Navigation } from "swiper";
import { Pagination } from "swiper";
import moment from "moment";
import String from "../../../lang/String";
import SkeletonEffect from "./SkeletonEffect";
import { Rating } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";

function Review(props) {
  const { windowSize, reviewData } = props;
  // console.log(windowSize);
  // console.log("review -->", reviewData);
  const arr = [
    {
      name: "kumar",
    },
    {
      name: "kumar",
    },
    {
      name: "kumar",
    },
    {
        name: "kumar",
      },
      {
        name: "kumar",
      },
      {
        name: "kumar",
      },
  ];
  return (
    <div className="container mt-4">
      <p className="h3 text-center" style={{ color: Colors.Base_color }}>
        {String.home_headings.Ccustomer_review}
      </p>
      <div className="container d-flex flex-row align-items-center" role="button">
      <img
          className="review-swiper-button-prev-1"
          src={images.left}
          alt="left"
          width="30"
          height="30"
        />
        <Swiper
          // slidesPerView={3}
          slidesPerView={windowSize != null && windowSize >= 1440 ? 3 : (windowSize >= 1024 ? 3 : (windowSize >= 768 ? 2 : 1 ))}
          spaceBetween={10}
          navigation={{
            nextEl: ".review-swiper-button-next-1",
            prevEl: ".review-swiper-button-prev-1",
          }}
          // modules={[]}
          modules={[Pagination, Navigation]}
          className="mySwiper"
        >
          {reviewData && reviewData != null ? (
            reviewData.map((data) => {
              return (
                <SwiperSlide>
                <div
                  className="d-flex flex-column p-2 mx-2 my-4 review-box"
                  style={{
                    backgroundColor: "#126a38",
                    // width: "100%",
                    borderRadius: "20px",
                    justifyContent: 'center'
                  }}
                >
                  <div style={{
                    display:'flex',
                    flexDirection:'row'
                  }}>
                  <img
                    src={data.customer_image && data.customer_image != "" ? Web_url.Domain_url+data.customer_image :images.user_new }
                    // src={images.reviewUser}
                    alt="review user"
                    width="50"
                    height="50"
                    className="rounded-circle img-fluid m-3"
                    style={{width: '60px',
                      height: '60px',
                      objectFit: 'cover'}}
                  />
                  <div style={{
                    display:'block',
                    alignContent: 'center'
                  }}>
                  <b
                    className=" mb-0 h5"
                    style={{ color: Colors.white_color }}
                  >
                    {data.customer_name}
                  </b>
                  <br></br>
                  
                  <Rating
                    className="mb-0 h5"
                    style={{ fontSize: "25px" }}
                    id="rating"
                    name="no-value"
                    value={data.ratings}
                    readOnly
                    sx={{
                      "& .MuiRating-iconFilled": { color: "#faaf00" }, // Filled stars in white
                      "& .MuiRating-iconEmpty": { color: "white" }, // Outlined stars in white
                    }}
                    icon={<StarIcon fontSize="inherit" />}
                    emptyIcon={<StarBorderIcon fontSize="inherit" />}
                  />
                  </div>
                  </div>
                  {/* <small className="mx-3 rev-text" style={{ color: "gray" }}>
                    {moment(data.created_at).format('DD-MMM-YY')}
                  </small> */}
                  <small className="m-3 rev-text" style={{ color: Colors.white_color, fontSize: windowSize > 512 ? '13px' : '12px' }}>
                    {data.feedbacks}
                  </small>
                </div>
                </SwiperSlide>
              );
            })
          ) : (
            arr.map((data) => {
              return (
                <SwiperSlide>
                  <SkeletonEffect className={"review-box my-2"} />
                {/* <div
                  className="d-flex flex-column p-2 mx-2 my-4 review-box"
                  style={{
                    backgroundColor: "#126a38",
                    width: "100%",
                    borderRadius: "20px",
                  }}
                >
                  <img
                    src={images.reviewUser}
                    alt="review user"
                    width="50px"
                    height="50px"
                    className="rounded-circle img-fluid m-3"
                  />
                  <b
                    className="mx-3 mb-0 h5"
                    style={{ color: Colors.white_color }}
                  >
                    John Deo
                  </b>
                  <small className="mx-3 rev-text" style={{ color: "gray" }}>
                    08-Aug-22
                  </small>
                  <small className="m-3 rev-text" style={{ color: Colors.white_color }}>
                    HTML Tutorial CSS Tutorial JavaScript Tutorial How To
                    Tutorial SQL Tutorial Python Tutorial W3.CSS Tutorial
                    Bootstrap Tutorial PHP Tutorial Java Tutorial ertificate
                    Python Certificate PHP Certificate jQuery Certificate Java
                    Certificate C++ Certificate C# Certificate XML Certificate
                  </small>
                </div> */}
                </SwiperSlide>
              );
            })

          )}
        </Swiper>
        <img
          className="review-swiper-button-next-1"
          src={images.right}
          alt="left"
          width="30"
          height="30"
        />
      </div>
    </div>
  );
}

export default Review;
